export default __webpack_public_path__ + "static/media/fiverrlogo2.179a1e9f.png";